module.exports = __webpack_public_path__ + "./docs/img/big-icon-folder.d1b4b248680e9116f2a997fa4c20cd02.svg";